module.exports = __webpack_public_path__ + "static/media/1.016a132e.png";